var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"buttons-group"},[_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":_vm.link}},[_vm._v("\n    Tickets\n    "),_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.params.data.cantidad_tickets))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }